import { render, staticRenderFns } from "./cImg.vue?vue&type=template&id=1ba452a3&"
import script from "./cImg.vue?vue&type=script&lang=js&"
export * from "./cImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports